module.exports = __webpack_public_path__ + "static/media/zlto-esd-graphic-business.908688ae.svg";